import { Alert } from 'antd';

/**
 * The sign-in code itself, on a test deployment that shows codes instead of emailing them
 * (`EMAIL_CODE_DISPLAY_ENABLED`; production refuses it). Says so, so nobody waits for an email.
 */
export function DisplayedCodeNotice({ code, className }: { code: string; className?: string }) {
  return (
    <Alert
      className={className}
      type="info"
      showIcon
      title="Test environment: codes are shown here instead of emailed"
      description={
        <>
          Your code is <span className="font-mono text-base font-medium text-fg">{code}</span>
        </>
      }
    />
  );
}
